import { SystemClassifierItemDto } from '../../systemClassifier';

export interface PredefineClassifiers {
  minutes: Map<string, SystemClassifierItemDto>;
  hours: Map<string, SystemClassifierItemDto>;
  days: Map<string, SystemClassifierItemDto>;
  weekdays: Map<string, SystemClassifierItemDto>;
  months: Map<string, SystemClassifierItemDto>;
}

export enum ExecutionMethod {
  CALENDAR = 'CALENDAR',
  MANUAL = 'MANUAL',
  PERIODIC = 'PERIODIC',
  SOURCE_DRIVEN = 'SOURCE_DRIVEN',
}
